import { render, staticRenderFns } from "./SettingsEdit.vue?vue&type=template&id=4666dd3e"
import script from "./SettingsEdit.vue?vue&type=script&lang=js"
export * from "./SettingsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports